import { useState } from "react";
import { userLogin, userSignup, volunteerLogin } from "../../API/index.ts";
import { Button } from "./ButtonWasty";
import { Card } from "./Card.tsx";
import { queueApiCall } from "../../offlinerHelper.tsx";

const AuthScreen = ({ volunterlogin, isSignUp, onAuthSuccess, onSwitchScreen, currentUser, setCurrentUser }) => {
  const [name, setName] = useState('');
  const [shopName, setShopName] = useState('');
  const [shopId, setShopId] = useState('');
  const [shopdbId, setShopdbId] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [ownerPhotoFile, setOwnerPhotoFile] = useState(null);
  const [volunteerId, setVolunteerId] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // ✅ Volunteer Login Case
    if (volunterlogin) {
      if (!volunteerId || !password) {
        alert("Please enter both Volunteer ID and Password.");
        setLoading(false);
        return;
      }

      try {
        const response = await volunteerLogin(volunteerId, password);
        setLoading(false);
        alert(`Welcome Volunteer ${response?.volunteer_name || ''}!`);
        onAuthSuccess('volunteer');
      } catch (apiErr) {
        setLoading(false);
        alert(`Volunteer login failed: ${apiErr?.response?.data?.detail || apiErr?.message}`);
      }
      return;
    }

    // ✅ Shop Owner Sign Up
    if (isSignUp) {
      if (!name || !shopName || !phoneNumber || !password || !ownerPhotoFile) {
        alert('Please fill all required fields and upload a photo.');
        setLoading(false);
        return;
      }

      try {
        const formData = new FormData();
        formData.append("owner_name", name);
        formData.append("shop_name", shopName);
        if (shopId) formData.append("shop_id", shopId); // ✅ Optional now
        formData.append("phone_number", phoneNumber);
        formData.append("password", password);
        formData.append("photo", ownerPhotoFile);

        const response = await userSignup(formData);
        //  const response = await queueApiCall(userSignup, formData, { queueName: "signup" });
  if (response.offlineSaved) {
    alert("📦 Stored offline — will sync when online!");
  } else {
    alert("✅ Signup successful!");
  }
        localStorage.setItem("loggedInUser", JSON.stringify(response));
        localStorage.setItem("userType", "user");

        setCurrentUser(response);
        setShopdbId(response?.id);
        setShopId(response?.shop_id);

        alert(`Signup successful! Welcome ${response?.owner_name || ''}.`);
        onAuthSuccess("user");
      } catch (error) {
        setLoading(false);
        alert(`Signup failed: ${error.response?.data?.detail || error.message}`);
      }
      return;
    }

    // ✅ Shop Owner Login with phone number + password
    if (!phoneNumber || !password) {
      alert("Please enter your phone number and password.");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        phone_number: phoneNumber,
        password: password
      };
      const response = await userLogin(phoneNumber, password);
      localStorage.setItem("loggedInUser", JSON.stringify(response));
      localStorage.setItem("userType", "user");

      setCurrentUser(response);
      setShopdbId(response?.id);
      alert(`Login successful! Welcome back ${response?.owner_name || ''}.`);
      onAuthSuccess('user');
    } catch (error) {
      setLoading(false);
      alert(`Login failed: ${error.response?.data?.detail || error.message}`);
    }
  };

  return (
    <Card
      title={
        volunterlogin
          ? "Volunteer Login"
          : isSignUp
            ? "Shop Owner Sign Up"
            : "Shop Owner Login"
      }
      className="w-full max-w-md"
    >
      <form onSubmit={handleSubmit} className="space-y-4">

        {/* Volunteer Login */}
        {volunterlogin ? (
          <>
            {/* Volunteer ID */}
            <div>
              <label className="block text-gray-700 font-medium mb-1">Volunteer ID *</label>
              <input
                type="text"
                value={volunteerId}
                onChange={(e) => setVolunteerId(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                placeholder="VOL-12345"
                required
              />
            </div>

            {/* Password */}
            <div>
              <label className="block text-gray-700 font-medium mb-1">Password *</label>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                placeholder="••••••••"
                required
              />
            </div>

            <Button loading={loading} type="submit" className="w-full mt-6" variant="primary">
              Sign In
            </Button>
          </>
        ) : (
          <>
            {/* --- SIGNUP --- */}
            {isSignUp && (
              <>
                <p className="text-sm text-red-600 font-medium">* Required fields</p>

                {/* Owner Name */}
                <div>
                  <label className="block text-gray-700 font-medium mb-1">Owner Name *</label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    placeholder="John Doe"
                    required
                  />
                </div>

                {/* Shop Name */}
                <div>
                  <label className="block text-gray-700 font-medium mb-1">Shop Name *</label>
                  <input
                    type="text"
                    value={shopName}
                    onChange={(e) => setShopName(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    placeholder="Example Store"
                    required
                  />
                </div>

                {/* Optional Shop ID */}
                <div>
                  <label className="block text-gray-700 font-medium mb-1">Shop ID (optional)</label>
                  <input
                    type="text"
                    value={shopId}
                    onChange={(e) => setShopId(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    placeholder="J-12A4 (optional)"
                  />
                </div>

                {/* Phone Number */}
                <div>
                  <label className="block text-gray-700 font-medium mb-1">Phone Number *</label>
                  <input
                    type="tel"
                    value={phoneNumber}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, '');
                      if (val.length <= 10) setPhoneNumber(val);
                    }}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    placeholder="9876543210"
                    required
                  />
                </div>

                {/* Owner Photo */}
                <div>
                  <label className="block text-gray-700 font-medium mb-1">Owner Photo *</label>
                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"   // <-- opens the back camera
                    onChange={(e) => setOwnerPhotoFile(e.target.files[0])}
                    className="w-full text-sm"
                    required
                  />
                </div>

              </>
            )}

            {/* --- LOGIN --- */}
            {!isSignUp && (
              <>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">Phone Number *</label>
                  <input
                    type="tel"
                    value={phoneNumber}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, '');
                      if (val.length <= 10) setPhoneNumber(val);
                    }}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    placeholder="9876543210"
                    required
                  />
                </div>
              </>
            )}

            {/* Password */}
            <div>
              <label className="block text-gray-700 font-medium mb-1">Password *</label>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                placeholder="••••••••"
                required
              />
            </div>

            <Button loading={loading} type="submit" className="w-full mt-6" variant="primary">
              {isSignUp ? "Register & Continue" : "Sign In"}
            </Button>

            <p className="text-center mt-4 text-sm text-gray-600">
              {isSignUp ? "Already have an account? " : "New user? "}
              <button
                onClick={() => onSwitchScreen(!isSignUp)}
                className="text-indigo-600 font-semibold hover:underline"
              >
                {isSignUp ? "Sign In" : "Sign Up"}
              </button>
            </p>
          </>
        )}
      </form>
    </Card>
  );
};
export default AuthScreen;